import { render, staticRenderFns } from "./DetailsStudentInfoTab.vue?vue&type=template&id=60c605c4&scoped=true&"
import script from "./DetailsStudentInfoTab.vue?vue&type=script&lang=ts&"
export * from "./DetailsStudentInfoTab.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsStudentInfoTab.vue?vue&type=style&index=0&id=60c605c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c605c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow,VTab,VTabItem,VTabs})
